export default {
    SET_SETTINGS(state, settings) {
        state.settings = settings
    },
    SET_INCIDENT_STATUS(state, incidentStatus) {
        state.incidentStatus = incidentStatus
    }
}
